import { render, staticRenderFns } from "./ImportView.vue?vue&type=template&id=28cca3e6&scoped=true&"
import script from "./ImportView.vue?vue&type=script&lang=js&"
export * from "./ImportView.vue?vue&type=script&lang=js&"
import style0 from "./ImportView.vue?vue&type=style&index=0&id=28cca3e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cca3e6",
  null
  
)

export default component.exports